'use strict';exports.__esModule = true;var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _ramda = require('ramda');
var _validate = require('./validate');var _validate2 = _interopRequireDefault(_validate);
var _Constants = require('../../containers/MyStaffContainer/Constants');


var _MyStaffEmployeesFormUpdate = require('./MyStaffEmployeesFormUpdate');var _MyStaffEmployeesFormUpdate2 = _interopRequireDefault(_MyStaffEmployeesFormUpdate);
var _index = require('../index');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var mapStateToProps = function mapStateToProps(_, props) {var _initialValues;
  var image = props.image ? props.image : null;
  var angle = _index.UploadAssetWidget.getAngle({ full: image });
  var linkId = image && image.split('/').pop();
  return {
    form: 'my-staff-employee-update-' + props.id,
    initialValues: (_initialValues = {}, _initialValues[
    _Constants.EMPLOYEES_FIELD_NAMES.NAME] = String(props.name || ''), _initialValues[
    _Constants.EMPLOYEES_FIELD_NAMES.LICENSE_NUMBER] = String(props.license_number || ''), _initialValues[
    _Constants.EMPLOYEES_FIELD_NAMES.PHONE_NUMBER] = String(props.phone_number || ''), _initialValues[
    _Constants.EMPLOYEES_FIELD_NAMES.IMAGE] = props.image ? { link: linkId, angle: angle || 0 } : null, _initialValues) };


};exports.default =

(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps),
(0, _reduxForm.reduxForm)({
  validate: _validate2.default }))(_MyStaffEmployeesFormUpdate2.default);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MyStaffEmployeesCard/MyStaffEmployeesForm.js
// module id = 2712
// module chunks = 0